import queryGQL from "@/Apollo/query/order/sales.graphql";
import { SalesQuery, SalesQueryVariables } from "@/Apollo/schema";
import { QueryHookOptions, useQuery } from "@apollo/client";

export const useSales = (
  options?: QueryHookOptions<SalesQuery, SalesQueryVariables>
) => {
  return useQuery(queryGQL, options);
};
